export default __webpack_public_path__ + "assets/arrival-component.3260285d.svg";